import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/lib/utils';

import { LocalImage, type LocalImageProps } from '../LocalImage';

export const imageButtonPropsVariants = cva('flex flex-wrap', {
    variants: {},
    defaultVariants: {},
});

export interface ImageButtonProps
    extends React.HTMLAttributes<HTMLAnchorElement>,
        VariantProps<typeof imageButtonPropsVariants> {
    href: string;
    image: LocalImageProps;
}

const ImageButton = React.forwardRef<HTMLAnchorElement, ImageButtonProps>(
    ({ href, image, className, ...props }, ref) => (
        <a
            href={href}
            target="_blank"
            className={cn(imageButtonPropsVariants({ className }))}
            ref={ref}
            {...props}
        >
            <LocalImage
                {...image}
                width={135}
                height={40}
            />
        </a>
    ),
);

export default ImageButton;
